/**
 * CLE-3015 PR 4 — the knowledge check and certificate pages. No imports, so the curriculum can use them
 * without an import cycle.
 */
export const QUIZ_PATH = "/training/quiz";
export const CERTIFICATE_PATH = "/training/certificate";

/** A module's quiz (CLE-3015, John's review): the tour sends the trainee here after the module's last step. */
export const moduleQuizPath = (module: number) =>
  `/training/module/${module}/quiz`;
